import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

export function ComingSoon () {
    return (
        <DotLottieReact
            src="/assets/lottie/coming-soon.lottie"
            style={{padding: 0, height: '300px'}}
            loop
            renderConfig={{autoResize: true}}
            autoplay
        />
    );
}
